module.exports = __webpack_public_path__ + "static/img/footermovibot.c805b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footermovibot.png
// module id = wCqv
// module chunks = 1